import React from "react";

export interface Beneficiary {
  id: string;
  name: string;
  dni: string;
  relationship: string;
  percentage: number;
}

export const RELATIONSHIPS = [
  { value: "spouse", key: "newDashboard.beneficiaryManager.relationship.spouse" },
  { value: "child", key: "newDashboard.beneficiaryManager.relationship.child" },
  { value: "parent", key: "newDashboard.beneficiaryManager.relationship.parent" },
  { value: "sibling", key: "newDashboard.beneficiaryManager.relationship.sibling" },
  { value: "other", key: "newDashboard.beneficiaryManager.relationship.other" },
];

export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "10px 14px",
  fontSize: 15,
  border: "1px solid #d1d5db",
  borderRadius: 8,
  outline: "none",
  color: "#111827",
  backgroundColor: "#fff",
  transition: "border-color 0.15s",
};

export const labelStyle: React.CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  marginBottom: 6,
  display: "block",
};
